module.exports = __webpack_public_path__ + "media/images/landkit/icons/payment-methods/mastercard-c85db9bda9e087366115f48db855f60a.svg";